import { FC, lazy } from 'react'
import { RouteObject, useLocation } from 'react-router-dom'
import { LazyComponent } from '../features/lazy-component'
import { Segment } from '../features/segment'

const Profile = lazy(() => import('../__legacy__/components/profile/ProfilePage'))

const ProfilePage: FC = () => {
  const { pathname } = useLocation()
  return (
    <Segment.ViewTracker attributes={{ path: '/profile', walletAddress: pathname.split('/')[2] }}>
      <LazyComponent>
        <Profile />
      </LazyComponent>
    </Segment.ViewTracker>
  )
}

// TODO: add skeleton and error components
export const ProfilePageRoute: RouteObject = {
  path: '/profile/:wallet_address/*',
  element: <ProfilePage />
}
